var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRub = function SvgRub(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 60 60",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.54 0h3.05c11.87.57 22.88 8.73 26.72 19.98-18.87.04-37.75.02-56.63.02C5.55 8.7 16.61.5 28.54 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0039A6",
    d: "M0 28.53c.2-2.9.81-5.76 1.68-8.53 18.88 0 37.76.02 56.63-.02.89 2.74 1.45 5.58 1.69 8.45v3.27c-.25 2.82-.82 5.61-1.68 8.3-18.88 0-37.76-.01-56.64.01C.79 37.26.23 34.4 0 31.52v-2.99z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D52B1E",
    d: "M1.68 40.01c18.88-.02 37.76-.01 56.64-.01-3.86 11.27-14.86 19.44-26.75 20h-3.23C16.5 59.39 5.53 51.25 1.68 40.01z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRub);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "RUB.ff42bf54b277af03a3473b298c4ccb4b.svg";